import pageView from './pageView';
var Criteo = {
  pageview: [pageView]
};
export default Criteo;